module.exports = __webpack_public_path__ + "d8440fd0141f6bd83b9438fc76b8ef9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/leftright.png
// module id = 323
// module chunks = 0